<script setup>
import { defineProps } from 'vue';

defineProps({
    title: String,
    value: [String, Number],
    icon: String, // Material Icon name
    color: String // e.g., 'blue', 'purple', 'red'
});

const colorClasses = {
    blue: 'bg-blue-100 text-blue-600',
    purple: 'bg-purple-100 text-purple-600',
    red: 'bg-red-100 text-red-600',
    gray: 'bg-gray-100 text-gray-600',
    green: 'bg-green-100 text-green-600',
};
</script>

<template>
    <div class="bg-white p-5 rounded-lg border border-gray-200 flex items-center space-x-4">
        <div class="flex-shrink-0">
            <div :class="[colorClasses[color], 'w-10 h-10 rounded-full flex items-center justify-center']">
                <q-icon :name="icon" size="xs" />
            </div>
        </div>
        <div class="flex flex-col justify-center items-center">
            <p class="text-sm font-medium text-gray-500 truncate">{{ title }}</p>
            <p class="mt-1 text-2xl font-semibold text-gray-900">{{ value }}</p>
        </div>
    </div>
</template>